 export const surfaceColors = {
        Quick: 'blue',
        Hard: 'geekblue',
        Clay: 'volcano',
        Grass: 'green',
    }